export default "<h1>Type4Fraction list</h1>\n<spec-app-type4-fraction-table [clickHandler]=\"createClickHandler()\"></spec-app-type4-fraction-table>";